// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { useRef } from 'react';

declare global {
  // eslint-disable-next-line no-var
  var useIdValue: number;
}

/**
 * Generates a unique (stable) ID for a component. Should be replaced with React.useId once we support only React 18.
 */
export function useId(prefix: string): string {
  if (globalThis.useIdValue === undefined) {
    globalThis.useIdValue = 0;
  }

  const id = useRef<string | undefined>(undefined);
  if (id.current === undefined) {
    id.current = `${prefix}-${globalThis.useIdValue++}`;
  }
  return id.current;
}
